<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.cloudpit_settings.form.login_url')"
            :is-required="true"
            :error="errorsData.login_url"
            :hint="__('settings.cloudpit_settings.form.login_url_hint')"
        >
            <DInput
                id="login_url"
                v-model="form.login_url"
                :placeholder="__('settings.cloudpit_settings.form.login_url')"
                :is-valid="isFormFieldValid('login_url')"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.cloudpit_settings.form.api_url')"
            :is-required="true"
            :error="errorsData.api_url"
            :hint="__('settings.cloudpit_settings.form.api_url_hint')"
        >
            <DInput
                id="api_url"
                v-model="form.api_url"
                :placeholder="__('settings.cloudpit_settings.form.api_url')"
                :is-valid="isFormFieldValid('api_url')"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.cloudpit_settings.form.service_url')"
            :is-required="true"
            :error="errorsData.service_url"
            :hint="__('settings.cloudpit_settings.form.service_url_hint')"
        >
            <DInput
                id="api_url"
                v-model="form.service_url"
                :placeholder="__('settings.cloudpit_settings.form.service_url')"
                :is-valid="isFormFieldValid('service_url')"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.cloudpit_settings.form.client_id')"
            :is-required="true"
            :error="errorsData.client_id"
            :hint="__('settings.cloudpit_settings.form.client_id_hint')"
        >
            <DInput
                id="client_id"
                v-model="form.client_id"
                :placeholder="__('settings.cloudpit_settings.form.client_id')"
                :is-valid="isFormFieldValid('client_id')"
                type="number"
                min="0"
                max="4294967295"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.cloudpit_settings.form.client_secret')"
            :is-required="cloudpitSettings === null"
            :error="errorsData.client_secret"
            :hint="__('settings.cloudpit_settings.form.client_secret_hint')"
        >
            <DInput
                id="client_secret"
                v-model="form.client_secret"
                :placeholder="__('settings.cloudpit_settings.form.client_secret')"
                :is-valid="isFormFieldValid('client_secret')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.cloudpit_settings.form.login_digits')"
            :is-required="true"
            :error="errorsData.login_digits"
            :hint="__('settings.cloudpit_settings.form.login_digits_hint')"
        >
            <DInput
                id="login_digits"
                v-model="form.login_digits"
                :placeholder="__('settings.cloudpit_settings.form.login_digits')"
                :is-valid="isFormFieldValid('login_digits')"
                type="number"
                min="0"
                max="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.cloudpit_settings.form.login_prefix')"
            :is-required="true"
            :error="errorsData.login_prefix"
            :hint="__('settings.cloudpit_settings.form.login_prefix_hint')"
        >
            <DInput
                id="login_prefix"
                v-model="form.login_prefix"
                :placeholder="__('settings.cloudpit_settings.form.login_prefix')"
                :is-valid="isFormFieldValid('login_prefix')"
                maxlength="6"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.cloudpit_settings.form.slug')"
            :is-required="true"
            :error="errorsData.slug"
            :hint="__('settings.cloudpit_settings.form.slug_hint')"
        >
            <DInput
                id="slug"
                v-model="form.slug"
                :placeholder="__('settings.cloudpit_settings.form.slug')"
                :is-valid="isFormFieldValid('slug')"
                maxlength="20"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.cloudpit_settings.form.dns_client_login')"
            :is-required="true"
            :error="errorsData.dns_client_login"
            :hint="__('settings.cloudpit_settings.form.dns_client_login_hint')"
        >
            <DInput
                id="dns_client_login"
                v-model="form.dns_client_login"
                :placeholder="__('settings.cloudpit_settings.form.dns_client_login')"
                :is-valid="isFormFieldValid('dns_client_login')"
                maxlength="20"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-show="apiConnectionStatus === 'successful'"
                    class="green-text"
                >
                    {{ __('settings.cloudpit_settings.connection_successful') }}
                </div>
                <div
                    v-show="apiConnectionStatus === 'unsuccessful'"
                    class="red-text"
                >
                    {{ __('settings.cloudpit_settings.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="__('settings.cloudpit_settings.check_api_connection')"
                    :disabled="isInLoadingState"
                    @click="checkApiConnection"
                />
            </DCol>
        </DRow>
        <DFormRow
            :label="__('settings.cloudpit_settings.form.graphql_api_url')"
            :is-required="true"
            :error="errorsData.graphql_api_url"
            :hint="__('settings.cloudpit_settings.form.graphql_api_url_hint')"
        >
            <DInput
                id="api_url"
                v-model="form.graphql_api_url"
                :placeholder="__('settings.cloudpit_settings.form.graphql_api_url')"
                :is-valid="isFormFieldValid('graphql_api_url')"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.cloudpit_settings.form.graphql_token')"
            :is-required="cloudpitSettings === null"
            :error="errorsData.graphql_token"
            :hint="__('settings.cloudpit_settings.form.graphql_token_hint')"
        >
            <DFormTextarea
                id="graphql_token"
                :model-value="form.graphql_token"
                :placeholder="__('settings.cloudpit_settings.form.graphql_token')"
                :is-valid="isFormFieldValid('graphql_token')"
                @update:modelValue="updateGraphqlToken"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-show="graphqlConnectionStatus === 'successful'"
                    class="green-text"
                >
                    {{ __('settings.cloudpit_settings.connection_successful') }}
                </div>
                <div
                    v-show="graphqlConnectionStatus === 'unsuccessful'"
                    class="red-text"
                >
                    {{ __('settings.cloudpit_settings.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="__('settings.cloudpit_settings.check_graphql_connection')"
                    :disabled="isInLoadingState"
                    @click="checkGraphqlConnection"
                />
            </DCol>
        </DRow>
        <DFormControls
            @submit="submitForm"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="closeErrorCheckModal"
        />
    </DForm>
</template>

<script>

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'

export default {
    name: 'CloudpitSettingsForm',
    components: {
        DConnectionErrorModal
    },
    props: {
        cloudpitSettings: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                login_url: this.cloudpitSettings?.login_url ?? null,
                api_url: this.cloudpitSettings?.api_url ?? null,
                service_url: this.cloudpitSettings?.service_url ?? null,
                client_id: this.cloudpitSettings?.client_id ?? null,
                client_secret: this.cloudpitSettings?.client_secret ?? null,
                login_digits: this.cloudpitSettings?.login_digits ?? null,
                login_prefix: this.cloudpitSettings?.login_prefix ?? null,
                slug: this.cloudpitSettings?.slug ?? null,
                dns_client_login: this.cloudpitSettings?.dns_client_login ?? null,
                graphql_api_url: this.cloudpitSettings?.graphql_api_url ?? null,
                graphql_token: this.cloudpitSettings?.graphql_token ?? null
            }),
            apiConnectionStatus: '',
            graphqlConnectionStatus: '',
            credentialsValid: false,
            error: null,
            errorsData: this.errors,
            connectionException: null
        }
    },
    watch: {
        form: {
            handler: function () {
                this.credentialsValid = false
            },
            deep: true
        }
    },
    methods: {
        submitForm () {
            this.apiConnectionStatus = ''
            this.graphqlConnectionStatus = ''
            this.credentialsValid = false
            this.$emit('form-submitted', this.form)
        },
        checkApiConnection () {
            this.errorsData = {}
            const self = this
            self.connectionException = null
            window.axios.post(this.$route('settings.cloudpit-settings.check-api-connection', this.form))
                .then(function () {
                    self.apiConnectionStatus = 'successful'
                    self.credentialsValid = true
                    self.connectionException = null
                    self.error = null
                })
                .catch(function (error) {
                    self.apiConnectionStatus = 'unsuccessful'
                    self.credentialsValid = false
                    if (error.response.data.error !== undefined) {
                        self.error = error.response.data.error
                    }
                    if (error.response.data.errors !== undefined) {
                        self.errorsData = error.response.data.errors

                        for (const key in self.errorsData) {
                            if (typeof self.errorsData[key] === 'object') {
                                self.errorsData[key] = self.errorsData[key][0]
                            }
                        }
                    }
                    if (error?.response.data.exception !== undefined) {
                        self.connectionException = error?.response.data.exception
                    }
                })
        },
        checkGraphqlConnection () {
            this.errorsData = {}
            const self = this
            self.connectionException = null
            window.axios.post(this.$route('settings.cloudpit-settings.check-graphql-connection', this.form))
                .then(function () {
                    self.graphqlConnectionStatus = 'successful'
                    self.credentialsValid = true
                    self.connectionException = null
                    self.error = null
                })
                .catch(function (error) {
                    self.graphqlConnectionStatus = 'unsuccessful'
                    self.credentialsValid = false
                    if (error.response.data.error !== undefined) {
                        self.error = error.response.data.error
                    }
                    if (error.response.data.errors !== undefined) {
                        self.errorsData = error.response.data.errors

                        for (const key in self.errorsData) {
                            if (typeof self.errorsData[key] === 'object') {
                                self.errorsData[key] = self.errorsData[key][0]
                            }
                        }
                    }
                    if (error?.response.data.exception !== undefined) {
                        self.connectionException = error?.response.data.exception
                    }
                })
        },
        updateGraphqlToken (token) {
            this.form.graphql_token = token
        },
        closeErrorCheckModal () {
            this.connectionException = null
            this.error = null
        }
    }
}
</script>

<style lang="scss" scoped>
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}
.green-text {
    color: green;
}
.red-text {
    color: red;
}
</style>
